import { getPortalId } from 'usage-tracker-core/common/defaultTrackers';

// Used to provide App Info to the Session Replay Tracking/Config Endpoint
const getAppInfo = () => {
  var _window$hubspot$bende, _window$hubspot, _window$hubspot$bende2, _window$hubspot2, _getPortalId;
  return {
    // retrieves the deployable name if available from window context
    // @ts-expect-error this is a global variable and we don't have control over it
    name: (_window$hubspot$bende = (_window$hubspot = window.hubspot) === null || _window$hubspot === void 0 || (_window$hubspot = _window$hubspot.bender) === null || _window$hubspot === void 0 ? void 0 : _window$hubspot.currentProject) !== null && _window$hubspot$bende !== void 0 ? _window$hubspot$bende : 'unknown',
    // retrieves the deployable version if available from window context
    // @ts-expect-error this is a global variable and we don't have control over it
    version: (_window$hubspot$bende2 = (_window$hubspot2 = window.hubspot) === null || _window$hubspot2 === void 0 || (_window$hubspot2 = _window$hubspot2.bender) === null || _window$hubspot2 === void 0 ? void 0 : _window$hubspot2.currentProjectVersion) !== null && _window$hubspot$bende2 !== void 0 ? _window$hubspot$bende2 : 'unknown',
    // retrieves the portal id if available from the running context
    portalId: (_getPortalId = getPortalId()) !== null && _getPortalId !== void 0 ? _getPortalId : 'unknown'
  };
};

// Provides the `Authorization` Header (workaround) for providing relevant
// App Info and Portal ID to the Session Replay Tracking/Config Endpoint
/** @todo: this should be superseeded by Apmlitude's SDK `transportProvider` */
export const getAuthorizationKey = () => `${getAppInfo().name}:::${getAppInfo().version}:::${getAppInfo().portalId}`;

// Best-effort approach to determine if the user is on standalone mode or not
// since we can't know if the user is on standalone mode or not.
export const isTrackerInStandaloneMode = (...originalTrackArguments) =>
// In this case, clearly must be a standalone mode, because 3 properties are provided.
// Otherwise, this is a misuse of the regular events.yaml mode.
originalTrackArguments.length === 3 ||
// In this case the 2nd property is not an object, but the name of the event within
// standalone mode. Since during standalone mode the 2nd argument is the event name.
originalTrackArguments.length === 2 && typeof originalTrackArguments[1] !== 'object';

// Since Amplitude Session Replay SDK only has a `getSessionId` method, we want to get the current
// registered Device Id and Session Id from Amplitude, so we can compare if they match the current Tracker
// and if not replace them with the current Tracker's Device Id and Session Id
export const extractAmplitudeIdentifiers = amplitudeProperties => {
  var _sessionReplayId$spli;
  const sessionReplayId = amplitudeProperties['[Amplitude] Session Replay ID'];

  // If the property is not available, we return undefined for both Device Id and Session Id
  const [deviceId, sessionId] = (_sessionReplayId$spli = sessionReplayId === null || sessionReplayId === void 0 ? void 0 : sessionReplayId.split('/')) !== null && _sessionReplayId$spli !== void 0 ? _sessionReplayId$spli : [undefined, 0];
  return [deviceId, Number(sessionId)];
};